import type { ELanguage } from '../languageHelper';

import { type ITextBase, oftenUsedTranslations } from './oftenUsed';

export const employeeTalkTexts: ILangDataEmployeeTalk = {
    th: {
        noComponent: 'ไม่มีส่วนประกอบ',
        noPages: 'ไม่มีหน้า',
        pageNotFound: 'ไม่พบหน้า',
        nameGenderDefaultDescription: 'อัปเดตชื่อและเพศของคุณ',
        nameGenderDefaultTitle: 'ข้อมูลส่วนตัว',
        systemComponent: 'ส่วนประกอบระบบ',
        date: 'วันที่',
        cannotDeleteSystemComponent: 'ไม่สามารถลบส่วนประกอบระบบได้',
        cannotAddMultipleSystemComponents: 'คุณไม่สามารถเพิ่มส่วนประกอบระบบหลายชิ้นที่มีชนิดเดียวกันได้',
        showUpdateButton: 'แสดงปุ่มอัปเดต',
        hideUpdateButton: 'ซ่อนปุ่มอัปเดต',
        invalidJson: 'รูปแบบ JSON ไม่ถูกต้อง',
        invalidTemplate: 'รูปแบบเทมเพลตไม่ถูกต้อง',
        emptyImport: 'กรุณาใส่รหัส JSON',
        import: 'นำเข้า',
        cancel: 'ยกเลิก',
        close: 'ปิด',
        copyToClipboard: 'คัดลอกไปที่คลิปบอร์ด',
        copied: 'คัดลอกแล้ว!',
        importTemplateDescription: 'วางรหัส JSON ของเทมเพลตที่คุณต้องการนำเข้า',
        exportTemplateDescription: 'นี่คือรหัส JSON สำหรับเทมเพลตของคุณ คุณสามารถคัดลอกและบันทึกได้',
        importTemplate: 'นำเข้าเทมเพลต',
        exportTemplate: 'ส่งออกเทมเพลต',
        noIdProvided: 'ไม่ได้ระบุ ID',
        employeeTalkNotFound: 'ไม่พบการสนทนาของพนักงาน',
        errorLoadingEmployeeTalk: 'เกิดข้อผิดพลาดในการโหลดการสนทนาของพนักงาน',
        manager: 'ผู้จัดการ',
        employeeTalks: 'T4LO การสนทนากับพนักงาน',
        scheduledDate: 'วันที่กำหนด',
        actualDate: 'วันที่จริง',
        duration: 'ระยะเวลา',
        location: 'สถานที่',
        noEmployeeTalksFound: 'ไม่พบการสนทนากับพนักงาน',
        newEmployeeTalk: 'การสนทนากับพนักงานใหม่',
        editEmployeeTalk: 'แก้ไขการสนทนากับพนักงาน',
        descriptionPlaceholder: 'คำอธิบาย',
        versionReadOnly: 'เวอร์ชัน (อ่านอย่างเดียว)',
        componentName: 'ชื่อองค์ประกอบ',
        componentDescription: 'คำอธิบายองค์ประกอบ',
        addDescription: 'เพิ่มคำอธิบาย...',
        moveUp: 'เลื่อนขึ้น',
        moveDown: 'เลื่อนลง',
        suggestionDefaultTitle: 'ทักษะใดที่ขาดหายไปในโปรไฟล์และควรเพิ่ม?',
        suggestionDefaultDescription: 'ใช้แบบฟอร์มนี้เพื่อแนะนำทักษะ บทบาท หรือใบรับรองที่ควรเพิ่มลงในโปรไฟล์',
        oftenUsed: oftenUsedTranslations.th,
        template: 'เทมเพลต',
        templates: 'เทมเพลต',
        templateEditor: 'ตัวแก้ไขเทมเพลต',
        templateManager: 'ตัวจัดการเทมเพลต',
        preview: 'ดูตัวอย่าง',
        page: 'หน้า',
        pages: 'หน้า',
        section: 'ส่วน',
        sections: 'ส่วน',
        component: 'องค์ประกอบ',
        components: 'องค์ประกอบ',
        column: 'คอลัมน์',
        columns: 'คอลัมน์',
        twoColumns: '2 คอลัมน์',
        oneColumn: '1 คอลัมน์',
        addComponent: 'เพิ่มองค์ประกอบ',
        addSection: 'เพิ่มส่วน',
        addPage: 'เพิ่มหน้า',
        saveTemplate: 'บันทึกเทมเพลต',
        createTemplate: 'สร้างเทมเพลต',
        editTemplate: 'แก้ไขเทมเพลต',
        deleteTemplate: 'ลบเทมเพลต',
        confirmDeleteTemplate: 'คุณแน่ใจหรือว่าต้องการลบเทมเพลตนี้?',
        confirmDeletePage: 'คุณแน่ใจหรือว่าต้องการลบหน้านี้?',
        confirmDeleteSection: 'คุณแน่ใจหรือว่าต้องการลบส่วนนี้?',
        confirmDeleteComponent: 'คุณแน่ใจหรือว่าต้องการลบองค์ประกอบนี้?',
        editPage: 'แก้ไขหน้า',
        editSection: 'แก้ไขส่วน',
        pageTitle: 'ชื่อหน้า',
        sectionTitle: 'ชื่อส่วน',
        componentType: 'ประเภทองค์ประกอบ',
        noTemplatesFound: 'ไม่พบเทมเพลต สร้างเทมเพลตแรกของคุณ!',
        backToList: 'กลับไปยังรายการ',
        finish: 'เสร็จสิ้น',
        status: 'สถานะ',
        name: 'ชื่อ',
        new: 'ใหม่',
        title: 'หัวข้อ',
        to: 'ไปยัง',
        list: 'รายการ',
        active: 'ใช้งาน',
        inactive: 'ไม่ใช้งาน',
        placeholder: 'ตัวอย่างข้อความ',
        maxLength: 'ความยาวสูงสุด',
        rows: 'จำนวนแถว',
        options: 'ตัวเลือก',
        addOption: 'เพิ่มตัวเลือก',
        multipleSelection: 'เลือกได้หลายรายการ',
        yes: 'ใช่',
        no: 'ไม่',
        text: 'ข้อความ',
        option1: 'ตัวเลือก 1',
        option2: 'ตัวเลือก 2',
        option3: 'ตัวเลือก 3',
    },
    en: {
        noComponent: 'No component',
        noPages: 'No pages',
        pageNotFound: 'Page not found',
        nameGenderDefaultDescription: 'Update your name and gender',
        nameGenderDefaultTitle: 'Personal Information',
        systemComponent: 'System component',
        date: 'Date',
        cannotDeleteSystemComponent: 'System components cannot be deleted',
        cannotAddMultipleSystemComponents: 'You cannot add multiple system components of the same type',
        showUpdateButton: 'Show update button',
        hideUpdateButton: 'Hide update button',
        invalidJson: 'Invalid JSON format',
        invalidTemplate: 'Invalid template format',
        emptyImport: 'Please enter a JSON code',
        import: 'Import',
        cancel: 'Cancel',
        close: 'Close',
        copyToClipboard: 'Copy to clipboard',
        copied: 'Copied!',
        importTemplateDescription: 'Paste the JSON code of the template you want to import.',
        exportTemplateDescription: 'Here is the JSON code for your template. You can copy and save it.',
        importTemplate: 'Import template',
        exportTemplate: 'Export template',
        noIdProvided: 'No ID provided',
        employeeTalkNotFound: 'Employee talk not found',
        errorLoadingEmployeeTalk: 'Error loading employee talk',
        scheduledDate: 'Scheduled Date',
        actualDate: 'Actual Date',
        duration: 'Duration',
        location: 'Location',
        noEmployeeTalksFound: 'No Employee Talks Found',
        newEmployeeTalk: 'New Employee Talk',
        editEmployeeTalk: 'Edit Employee Talk',
        employeeTalks: 'T4LO Employee discussions',
        versionReadOnly: 'Version (Read Only)',
        descriptionPlaceholder: 'Description',
        componentName: 'Component Name',
        componentDescription: 'Component Description',
        addDescription: 'Add description...',
        moveUp: 'Move Up',
        moveDown: 'Move Down',
        suggestionDefaultTitle: 'Which skills are missing in the profile and should be added?',
        suggestionDefaultDescription:
            'Use this form to suggest skills, roles, or certificates that should be added to the profile',
        oftenUsed: oftenUsedTranslations.en,
        template: 'Template',
        templates: 'Templates',
        templateEditor: 'Template Editor',
        templateManager: 'Template Manager',
        preview: 'Preview',
        page: 'Page',
        pages: 'Pages',
        section: 'Section',
        sections: 'Sections',
        component: 'Component',
        components: 'Components',
        column: 'Column',
        columns: 'Columns',
        twoColumns: '2 Columns',
        oneColumn: '1 Column',
        addComponent: 'Add Component',
        addSection: 'Add Section',
        addPage: 'Add Page',
        saveTemplate: 'Save Template',
        createTemplate: 'Create Template',
        editTemplate: 'Edit Template',
        deleteTemplate: 'Delete Template',
        confirmDeleteTemplate: 'Are you sure you want to delete this template?',
        confirmDeletePage: 'Are you sure you want to delete this page?',
        confirmDeleteSection: 'Are you sure you want to delete this section?',
        confirmDeleteComponent: 'Are you sure you want to delete this component?',
        editPage: 'Edit Page',
        editSection: 'Edit Section',
        pageTitle: 'Page Title',
        sectionTitle: 'Section Title',
        componentType: 'Component Type',
        noTemplatesFound: 'No templates found. Create your first template!',
        backToList: 'Back to List',
        finish: 'Finish',
        status: 'Status',
        name: 'Name',
        manager: 'Manager',
        new: 'New',
        title: 'Title',
        to: 'to',
        list: 'List',
        active: 'Active',
        inactive: 'Inactive',
        placeholder: 'Placeholder',
        maxLength: 'Max Length',
        rows: 'Rows',
        options: 'Options',
        addOption: 'Add Option',
        multipleSelection: 'Multiple Selection',
        yes: 'Yes',
        no: 'No',
        text: 'Text',
        option1: 'Option 1',
        option2: 'Option 2',
        option3: 'Option 3',
    },
    de: {
        oftenUsed: oftenUsedTranslations.de,
        template: 'Vorlage',
        date: 'Datum',
        templates: 'Vorlagen',
        templateEditor: 'Vorlagen-Editor',
        templateManager: 'Vorlagen-Verwaltung',
        preview: 'Vorschau',
        page: 'Seite',
        pages: 'Seiten',
        section: 'Abschnitt',
        sections: 'Abschnitte',
        component: 'Komponente',
        components: 'Komponenten',
        column: 'Spalte',
        columns: 'Spalten',
        twoColumns: '2 Spalten',
        oneColumn: '1 Spalte',
        addComponent: 'Komponente hinzufügen',
        addSection: 'Abschnitt hinzufügen',
        addPage: 'Seite hinzufügen',
        saveTemplate: 'Vorlage speichern',
        createTemplate: 'Vorlage erstellen',
        editTemplate: 'Vorlage bearbeiten',
        deleteTemplate: 'Vorlage löschen',
        confirmDeleteTemplate: 'Sind Sie sicher, dass Sie diese Vorlage löschen möchten?',
        confirmDeletePage: 'Sind Sie sicher, dass Sie diese Seite löschen möchten?',
        confirmDeleteSection: 'Sind Sie sicher, dass Sie diesen Abschnitt löschen möchten?',
        confirmDeleteComponent: 'Sind Sie sicher, dass Sie diese Komponente löschen möchten?',
        editPage: 'Seite bearbeiten',
        editSection: 'Abschnitt bearbeiten',
        pageTitle: 'Seitentitel',
        sectionTitle: 'Abschnittstitel',
        componentType: 'Komponententyp',
        noTemplatesFound: 'Keine Vorlagen gefunden. Erstellen Sie Ihre erste Vorlage!',
        backToList: 'Zurück zur Liste',
        finish: 'Abschließen',
        status: 'Status',
        name: 'Name',
        manager: 'Manager',
        new: 'Neu',
        title: 'Titel',
        to: 'zu',
        list: 'Liste',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        placeholder: 'Platzhalter',
        maxLength: 'Maximale Länge',
        rows: 'Zeilen',
        options: 'Optionen',
        addOption: 'Option hinzufügen',
        multipleSelection: 'Mehrfachauswahl',
        yes: 'Ja',
        no: 'Nein',
        text: 'Text',
        option1: 'Option 1',
        option2: 'Option 2',
        option3: 'Option 3',
        versionReadOnly: 'Version (Read Only)',
        descriptionPlaceholder: 'Beschreibung',
        componentName: 'Komponentenname',
        componentDescription: 'Komponentenbeschreibung',
        addDescription: 'Beschreibung hinzufügen...',
        moveUp: 'Nach oben',
        moveDown: 'Nach unten',
        suggestionDefaultTitle: 'Welche Skills fehlen im Profil und sollten aufgenommen werden?',
        suggestionDefaultDescription:
            'Verwenden Sie dieses Formular, um Skills, Rollen oder Zertifikate vorzuschlagen, die zum Profil hinzugefügt werden sollten',
        employeeTalks: 'T4LO Talks',
        editEmployeeTalk: 'Bearbeite Mitarbeitergespräch',
        newEmployeeTalk: 'Neues Mitarbeitergespräch',
        noEmployeeTalksFound: 'Keine Mitarbeitergespräche gefunden',
        location: 'Standort',
        duration: 'Dauer',
        actualDate: 'Aktuelles Datum',
        scheduledDate: 'Geplantes Datum',
        errorLoadingEmployeeTalk: 'Fehler beim Laden des Mitarbeitergesprächs',
        employeeTalkNotFound: 'Mitarbeitergespräch nicht gefunden',
        noIdProvided: 'Keine ID angegeben',
        exportTemplate: 'Template exportieren',
        importTemplate: 'Template importieren',
        exportTemplateDescription: 'Hier ist der JSON-Code für Ihr Template. Sie können ihn kopieren und speichern.',
        importTemplateDescription: 'Fügen Sie den JSON-Code des Templates ein, das Sie importieren möchten.',
        copied: 'Kopiert!',
        copyToClipboard: 'In Zwischenablage kopieren',
        close: 'Schließen',
        cancel: 'Abbrechen',
        import: 'Importieren',
        emptyImport: 'Bitte geben Sie einen JSON-Code ein',
        invalidTemplate: 'Ungültiges Template-Format',
        invalidJson: 'Ungültiges JSON-Format',
        hideUpdateButton: 'Update-Button ausblenden',
        showUpdateButton: 'Update-Button anzeigen',
        cannotAddMultipleSystemComponents: 'Du kannst nicht mehrere System-Komponenten des gleichen Typs hinzufügen',
        cannotDeleteSystemComponent: 'System-Komponenten können nicht gelöscht werden',
        systemComponent: 'System-Komponente',
        nameGenderDefaultTitle: 'Persönliche Informationen',
        nameGenderDefaultDescription: 'Aktualisiere deinen Namen und dein Geschlecht',
        pageNotFound: 'Seite nicht gefunden',
        noPages: 'Keine Seiten',
        noComponent: 'Keine Komponente',
    },
};

export interface IEmployeeTalkTexts extends ITextBase {
    pageNotFound: string;
    noPages: string;
    noComponent: string;
    nameGenderDefaultTitle: string;
    nameGenderDefaultDescription: string;
    hideUpdateButton: string;
    showUpdateButton: string;
    cannotAddMultipleSystemComponents: string;
    cannotDeleteSystemComponent: string;
    systemComponent: string;
    exportTemplate: string;
    importTemplate: string;
    exportTemplateDescription: string;
    importTemplateDescription: string;
    copied: string;
    copyToClipboard: string;
    close: string;
    cancel: string;
    import: string;
    emptyImport: string;
    invalidTemplate: string;
    invalidJson: string;
    errorLoadingEmployeeTalk: string;
    employeeTalkNotFound: string;
    noIdProvided: string;
    editEmployeeTalk: string;
    newEmployeeTalk: string;
    noEmployeeTalksFound: string;
    location: string;
    duration: string;
    scheduledDate: string;
    actualDate: string;
    employeeTalks: string;
    descriptionPlaceholder: string;
    versionReadOnly: string;
    componentName: string;
    componentDescription: string;
    addDescription: string;
    moveUp: string;
    moveDown: string;
    suggestionDefaultTitle: string;
    suggestionDefaultDescription: string;
    template: string;
    templates: string;
    templateEditor: string;
    templateManager: string;
    preview: string;
    page: string;
    pages: string;
    section: string;
    sections: string;
    component: string;
    components: string;
    column: string;
    columns: string;
    twoColumns: string;
    oneColumn: string;
    addComponent: string;
    addSection: string;
    addPage: string;
    saveTemplate: string;
    createTemplate: string;
    editTemplate: string;
    deleteTemplate: string;
    confirmDeleteTemplate: string;
    confirmDeletePage: string;
    confirmDeleteSection: string;
    confirmDeleteComponent: string;
    editPage: string;
    editSection: string;
    pageTitle: string;
    sectionTitle: string;
    componentType: string;
    noTemplatesFound: string;
    backToList: string;
    finish: string;
    status: string;
    name: string;
    manager: string;
    new: string;
    title: string;
    to: string;
    list: string;
    active: string;
    inactive: string;
    placeholder: string;
    maxLength: string;
    rows: string;
    options: string;
    addOption: string;
    multipleSelection: string;
    yes: string;
    no: string;
    text: string;
    option1: string;
    option2: string;
    option3: string;
    date: string;
}

type ILangDataEmployeeTalk = {
    [lang in ELanguage]: IEmployeeTalkTexts;
};
